export default "__VITE_ASSET__BPTd$50B__"